<section class="upload-form">
  <header class="upload-form__header">
    <h3 class="upload-form__title">{{ 'upload-form.add-details' | translate }}</h3>
    <p class="upload-form__subtitle">
      {{ 'upload-form.choose-a-name-for-this-model-in-your-project' | translate }}
    </p>
  </header>

  <form [formGroup]="form" class="upload-form__body">
    <div class="upload-form__field">
      <input
        hlmInput
        formControlName="modelName"
        [placeholder]="'upload-form.model-name' | translate"
        [attr.aria-label]="'upload-form.model-name' | translate"
      />
    </div>
    <div class="upload-form__field">
      <textarea
        hlmInput
        class="upload-form__description"
        formControlName="description"
        [placeholder]="'upload-form.description' | translate"
        [attr.aria-label]="'upload-form.description' | translate"
        rows="3"
      ></textarea>
    </div>
  </form>

  <div class="upload-form__actions">
    <button
      hlmBtn
      type="button"
      class="w-full"
      [disabled]="form.invalid || waiting()"
      (click)="onNext()"
    >
      @if (waiting()) {
        <hlm-spinner />
      } @else if (form.invalid) {
        <ocp-themed-icon name="checkmark-disabled.svg" mode="swap" />
      } @else {
        <ocp-themed-icon name="checkmark.svg" mode="swap" />
      }
      {{ 'upload-form.next' | translate }}
    </button>
    <button hlmBtn type="button" variant="secondary" class="w-full" (click)="onCancel()">
      <ocp-themed-icon name="cross.svg" />
      {{ 'upload-form.cancel' | translate }}
    </button>
  </div>
</section>
